import { render } from "./ChartTest.vue?vue&type=template&id=3c73bad0"
import script from "./ChartTest.vue?vue&type=script&lang=js"
export * from "./ChartTest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__